module.exports = __webpack_public_path__ + "flyer_background_beer_004-9e1c04f4a43ea2fdb0e4600c59c2b6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_beer_004.jpg
// module id = 1605
// module chunks = 1